import { Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import Footer from "./components/footer";
import Home from "./pages/home";
import LegalPage from "./pages/legal";
import { useEffect } from "react";
import ScrollToTopButton from "./components/ScrollToTopButton";
import { scrollToAnchor } from "./utils/scrolls";

function App() {
	const location = useLocation();

	useEffect(() => {
		if (location.hash) {
			const locationState = location.state as { skipHashScroll?: boolean } | null;
			if (locationState?.skipHashScroll) return;

			setTimeout(() => {
				scrollToAnchor(location.hash);
			}, 80);

			return;
		}

		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, [location.pathname, location.hash, location.state]);

	return (
		<div className="App">
			<div className="app-content">
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<LegalPage type="about" />} />
					<Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
					<Route path="/terms-of-use" element={<LegalPage type="terms" />} />
				</Routes>
				<ScrollToTopButton />
			</div>
			<Footer />
		</div>
	);
}

export default App;
